import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const formatTime = (time) => {
  const hour = new Date(time).getHours();
  const minute = new Date(time).getMinutes();

  return `${hour < 10 ? '0' : ''}${hour}:${minute < 10 ? '0' : ''}${minute}`;
};

const StopTimesCell = ({ timeFrom, timeTo }) => {
  const fromFormatted = formatTime(timeFrom);
  const toFormatted = formatTime(timeTo);

  if (fromFormatted === toFormatted) {
    return <Fragment>{toFormatted}</Fragment>;
  }

  return (
    <Fragment>
      {fromFormatted} - {toFormatted}
    </Fragment>
  );
};

StopTimesCell.propTypes = {
  timeFrom: PropTypes.string.isRequired,
  timeTo: PropTypes.string.isRequired,
};

export default StopTimesCell;
